import React, {Component} from 'react';
import {connect} from "react-redux";
import {addTranslations} from "../actions/TranslationActions";
import {bindActionCreators} from "redux";
import Loader from "../helpers/Loader";
import {DOMAIN} from "./ExpiredPriceNoticeContainer";
import Translator from "../helpers/Translator";

class ExpiredPriceNotice extends Component {
    componentDidMount() {
        let translations = {};
        translations[DOMAIN] = JSON.parse(this.props.dataTranslations);
        this.props.addTranslations(translations);
    }

    render() {
        if (Loader.showLoader(this.props.flights)) {
            return null;
        }

        if (this.props.recommended === null || this.props.recommended._id === this.props.cheapest._id) {
            return null;
        }

        let cheapestPrice = 0;
        if (this.props.cheapest && this.props.cheapest.length > 0) {
            for (let i = 0; i < this.props.cheapest.length; i++) {
                if (this.props.recommended._id === this.props.cheapest[i]._id) {
                    return null;
                } else {
                     cheapestPrice = this.props.cheapest[i].general.price;
                }
            }
        }
        cheapestPrice = parseFloat(cheapestPrice).toFixed(2);

        this.props.noticeParameters = JSON.parse(this.props.noticeParameters);

        if (cheapestPrice < this.props.noticeParameters.price) {
            return null;
        }

        this.translator = new Translator(this.props.translator, DOMAIN);

        return (
            <div className="alert alert-warning mt-3">
                {this.translator.trans('Warning') + '! ' + this.translator.trans('Offer price is expired, instead we offer to choose from bellow or do a new search')}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        addTranslations
    }, dispatch);
}

function mapStateToProps(state, ownProps) {
    return {
        dataTranslations: ownProps.translations,
        noticeParameters: ownProps.noticeParameters,
        translator: state.TranslationsReducer.translations,
        flights: state.FlightsReducer,
        recommended: state.FlightsReducer.recommended,
        cheapest: state.FlightsReducer.cheapest,
        parameters: state.ParametersReducer.parameters,
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ExpiredPriceNotice);



// WEBPACK FOOTER //
// ./src/components/ExpiredPriceNotice.js